import { render, staticRenderFns } from "./LeslycVipRoulette.vue?vue&type=template&id=7d7042d8&scoped=true&"
import script from "./LeslycVipRoulette.vue?vue&type=script&lang=js&"
export * from "./LeslycVipRoulette.vue?vue&type=script&lang=js&"
import style1 from "./LeslycVipRoulette.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7042d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
